

<div class="modal-body m-1  justify-content-start">
  <div class="modal-header d-block pt-0 ps-0 pe-0">
    <ul class="nav nav-pills nav-fill">
      <li class="nav-item" >
        <a class="nav-link" [class.active]="tabIndex==1" href="javascript:void(0);" (click)="setTabIndex(1)">Attachments</a>
      </li>
      <li *ngIf="!isReadOnly" class="nav-item" >
        <a class="nav-link" [class.active]="tabIndex==2" href="javascript:void(0);" (click)="setTabIndex(2)">Upload File</a>
      </li>
    </ul>
  </div>

  <div *ngIf="tabIndex==1" class="w-100 mt-3">
    <paetep-display-attachments [observationFiles]="observationFiles">
      <ng-template [paetepNested]="true" [paetepNestedTag]="CommentTags.Attachment" let-f>
        <paetep-attachment-button
          [attachment]="f" 
          [shouldDisplayDate]="false"
          [canDeleteAttachment]="isGeneralAttachment(f) && !isReadOnly"
          (onAttachmentDeleted)="onAttachmentDeleted($event)">
        </paetep-attachment-button>
      </ng-template>
    </paetep-display-attachments>
  </div>
  <div *ngIf="tabIndex==2" class="w-100 mt-3">
    <div class="row m-3">
      <form [formGroup]="form" (ngSubmit)="submit(form)" errorTailor>
          <div class="form-group">
              <label class="form-label" for="fileInput">Select File: <span class="required">*</span></label>
              <p class="mb-2">Files are limited to:</p>
                      <ul>
                          <li>20 MB size</li>
                          <li>Standard documents (PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX, TXT, RTF), images (JPG, PNG, JPEG, GIF), and audio files ( WAV, M4A, MP3)</li>
                      </ul>
              <div class="alert alert-danger" role="alert" *ngIf="invalidFile">
                The file is larger than the file size limit or is an invalid type. Please select a different file.
              </div>
              <input type="file" id="fileInput" class="form-control h-auto" placeholder="Upload Document" accept=".gif,.jpg,.jpeg,.tiff,.png,.doc,.docx,.xls,.xlsx,.pdf,.txt,.rtf,.ppt,.pptx,.m4a,.mp3,.wav,.aac"
                  (change)="onChange($event)"
                  [attr.aria-invalid]="fileNameControl?.invalid && fileNameControl?.touched ? 'true' : null"
                  [attr.aria-describedby]="fileNameControl?.invalid && fileNameControl?.touched ? 'FileName-error' : null"/>
              <div id="FileName-error"
                   class="invalid-feedback d-block"
                   role="alert"
                   *ngIf="fileNameControl?.invalid && fileNameControl?.touched">
                File is required.
              </div>

          </div>


          <div class="form-group">
              <button type="submit" class="btn btn-primary" [ladda]="busy">Upload</button>
          </div>
      </form>
  </div>
</div>
<div class="modal-footer">

  <button type="button" class="btn btn-info" (click)="close()">Close</button>
</div>

